module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskSort1-872c5fe56756ca0e1e3864d7fae6a50e.jpg";